import type React from 'react';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Text } from '@change/ds-core-ui';

import { useHighAmountConfirmationModal } from './hooks/useHighAmountConfirmationModal';

export const HighAmountConfirmationModal: React.FC = () => {
	const {
		data: { text, cancelLabel, confirmLabel, confirmDataQa, cancelDataQa, ariaLabel, showHighAmountConfirmationModal },
		actions: { confirmPromotionHighAmount, cancelHighAmountConfirmation },
	} = useHighAmountConfirmationModal();

	return (
		<Modal
			isOpen={showHighAmountConfirmationModal}
			aria-label={ariaLabel}
			onClose={cancelHighAmountConfirmation}
			className="z-999 *:min-h-[100px]!"
			size="small"
		>
			<ModalHeader />
			<ModalBody>
				<div className="mx-auto flex flex-col items-center gap-4 pt-4">
					<Text size="medium">{text}</Text>
				</div>
			</ModalBody>
			<ModalFooter>
				<Button onClick={confirmPromotionHighAmount} data-qa={confirmDataQa} variant="primary" size="small">
					{confirmLabel}
				</Button>
				<Button onClick={cancelHighAmountConfirmation} data-qa={cancelDataQa} variant="secondary" size="small">
					{cancelLabel}
				</Button>
			</ModalFooter>
		</Modal>
	);
};
